import { referralPriorAuthorizationPerson } from '@fireflyhealth/api'
import { useQuery } from '~/shared/hooks/query'
import { PriorAuthorizationListItem } from './types'
import { required } from '~/shared/lib/required'

// Shared custom hook for fetching prior authorizations
export const usePriorAuthorizations = (personId: number | null) => {
  return useQuery<PriorAuthorizationListItem[]>(
    personId != null
      ? referralPriorAuthorizationPerson.listQueryKey({ person_id: personId })
      : ['listReferralPriorAuthorizationPerson', null],
    async () => {
      const { data } = await referralPriorAuthorizationPerson.list({
        person_id: required(personId, 'a person id'),
      })
      return data
    },
    {
      enabled: !!personId,
      staleTime: 0,
      refetchOnWindowFocus: true,
    },
    { error: 'Unable to fetch Prior Authorizations for the person' },
  )
}
